import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    placeholder: String,
    maximumSelectionLength: Number
  }

  connect() {
    console.log("Select2 controller connected")
    this.initializeSelect2()
  }

  disconnect() {
    // Очистка при отключении
    if ($(this.element).hasClass("select2-hidden-accessible")) {
      $(this.element).select2('destroy')
    }
  }

  initializeSelect2() {
    if (window.Select2) {
      $(this.element).select2({
        theme: 'bootstrap-5',
        width: '100%',
        maximumSelectionLength: this.maximumSelectionLengthValue || null,
        placeholder: this.placeholderValue || "Выберите опцию",
        allowClear: true
      })
    } else {
      console.warn("Select2 library not found")
    }
  }
}
